import React from "react";
import {
  FaDiscord,
  FaDownload,
  FaGamepad,
  FaTrophy,
  FaUsers
} from "react-icons/fa";
import SEO from "../components/SEO";
import GameShowcasePage from "../components/GameShowcasePage";
import LeaderboardSection from "../components/zombiecrushers/LeaderboardSection";
import zombieCover from "../images/zombie_crushers_carousel_1600x1400.webp";

const DOWNLOAD_URL =
  "https://kyros-launcher-enterprise-929633566631.s3.eu-south-1.amazonaws.com/installer/KyrosSetup.exe";
const DISCORD_URL = "https://discord.gg/sFxWsn4ruU";

const storyParagraphs = [
  "Zombie Crushers \u00e8 il gioco da provare subito. Scarichi il launcher, avvii una run e provi a resistere pi\u00f9 a lungo degli altri.",
  "Le partite sono corte e leggibili: entri, combatti, fai punti, sbagli, riparti. La classifica serve a dare un motivo in pi\u00f9 per tornare.",
  "Non \u00e8 una promessa futura: il gioco \u00e8 gi\u00e0 disponibile e la leaderboard qui sotto mostra il lato competitivo."
];

const features = [
  {
    title: "Partite veloci",
    description:
      "Run brevi, facili da riprovare e pensate per migliorare un tentativo alla volta.",
    icon: FaGamepad
  },
  {
    title: "Classifica pubblica",
    description:
      "Punteggi e posizioni sono visibili dalla pagina, senza dover aprire il gioco.",
    icon: FaTrophy
  },
  {
    title: "Gratis dal launcher",
    description:
      "Lo aggiungi alla libreria Kyros e lo installi su Windows dal launcher ufficiale.",
    icon: FaUsers
  }
];

const facts = [
  { label: "Stato", value: "Disponibile" },
  { label: "Prezzo", value: "Gratis" },
  { label: "Piattaforma", value: "Windows" },
  { label: "Dove", value: "Kyros Launcher" }
];

export default function ZombieCrushersPage() {
  return (
    <>
      <SEO
        title="Zombie Crushers | Kyros Games"
        description="Zombie Crushers \u00e8 un survival arcade gratuito per Windows, con download dal launcher Kyros e classifica pubblica."
        canonical="https://kyrosgames.com/games/zombie-crushers"
        image="https://kyrosgames.com/images/zombie_crushers_carousel_1920x1080.webp"
        imageAlt="Key art di Zombie Crushers"
      />

      <GameShowcasePage
        theme="zombie"
        eyebrow="Disponibile gratis"
        title="Zombie Crushers"
        summary="Survival arcade per Windows. Scarica il launcher Kyros, entra in partita e prova a scalare la classifica."
        productCode="zombie-crushers"
        cover={zombieCover}
        coverAlt="Key art di Zombie Crushers"
        highlights={[
          "Gratis",
          "Windows",
          "Classifica attiva"
        ]}
        primaryAction={{
          label: "Scarica il launcher",
          href: DOWNLOAD_URL,
          download: true,
          icon: FaDownload
        }}
        secondaryAction={{
          label: "Entra nel Discord",
          href: DISCORD_URL,
          external: true,
          icon: FaDiscord
        }}
        storyTitle="Entra, resisti, riprova"
        storyParagraphs={storyParagraphs}
        features={features}
        facts={facts}
        leaderboardLabel="Classifica"
        leaderboardPanel={<LeaderboardSection embedded />}
      />
    </>
  );
}
